<section class="page-title-area">
    <div class="container">
        <div class="page-title-content" *ngFor="let pageTitle of pageTitleArea">
            <h2>{{ pageTitle.title }}</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>{{ pageTitle.title }}</li>
            </ul>
        </div>
    </div>

    <div class="shape-img1">
        <img src="assets/img/shape/shape1.svg" alt="image" />
    </div>
    <div class="shape-img2">
        <img src="assets/img/shape/shape2.png" alt="image" />
    </div>
    <div class="shape-img3">
        <img src="assets/img/shape/shape3.png" alt="image" />
    </div>
</section>

<section class="solutions-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div
                class="col-lg-4 col-md-6 col-sm-6"
                *ngFor="let solutionsBoxContent of singleSolutionsBox"
            >
                <div class="single-solutions-box">
                    <div class="icon">
                        <a routerLink="/{{ solutionsBoxContent.link }}"
                            ><img
                                [class]="solutionsBoxContent.imageClass"
                                src="{{ solutionsBoxContent.icon }}"
                        /></a>
                    </div>
                    <!-- <h3><a routerLink="/{{solutionsBoxContent.link}}">{{solutionsBoxContent.title}}</a></h3> -->
                    <p>{{ solutionsBoxContent.paragraphText }}</p>
                    <a
                        routerLink="/{{ solutionsBoxContent.link }}"
                        class="view-details-btn"
                        >{{ solutionsBoxContent.linkText }}</a
                    >
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <app-project-start></app-project-start> -->
